/**
 * Guide step 1: welcome.
 */
import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useAsterController } from "context";
import { VText, VImage } from "form";

/**
 * First onboarding slide for a course.
 */
const Guide1 = () => {
  const { t } = useTranslation("common");

  const { courseId } = useParams();

  const [controller] = useAsterController();
  const { courses } = controller;

  const currCourse = useMemo(() => (courses.data || []).find((v) => v.id === courseId) || {}, [courseId, courses.data]);

  const getWeeks = (start, end) => {
    start = Number(start);
    end = Number(end);

    if (start > end) return 0;
    if (!start || !end) return 52;

    const diff = Math.floor((end - start) / (1000 * 60 * 60 * 24 * 7));
    return diff;
  };

  return (
    <Box className="flex flex-col md:flex-row justify-center items-center w-full max-w-screen-xl mx-auto gap-10 md:py-10">
      <Box className="flex justify-center items-center md:w-6/12 w-full p-4 md:px-10 md:py-20">
        <VImage src={`${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/guide/guide1.svg`} className="w-full max-w-sm" draggable={false} />
      </Box>
      <Box className="flex flex-col gap-5 md:w-6/12 w-full">
        <VText className="text-4xl">{t("Welcome abroad")}</VText>
        <VText className="text-2xl">{t("This training developed by business experts is 100% online, tutored* and certifying.")}</VText>
        <VText className="text-2xl">
          {t("It is rhythmic on")}{" "}
          <VText className="text-orange-600">
            {getWeeks(currCourse.enroll_start, currCourse.enroll_end) || 0} {t("weeks")}
          </VText>
          , {t("allowing you to organize yourself with complete peace of mind.")}
        </VText>
        <VText className="text-2xl">{t("Discover now all the essential information for the success of your training.")}</VText>
      </Box>
    </Box>
  );
};

export default Guide1;
